import { BlobProvider, PDFViewer } from '@react-pdf/renderer';
import { Button, Col, Row } from 'antd';
import { useRef, useState } from 'react';
import SignaturePad from 'react-signature-canvas';
import { useFormContext } from '../../Context/DeclarationContext';
import { useTrackingContext } from '../../Context/TrackingContext';
import { getUrlFileBase64, putBase64File } from '../../Services/declarations';
import RutTools from '../../helpers/format-rut';
import SignatureDeclarations from '../Pdf/signature_declaration';
import './index.scss';

const SignatureForm = ({ openModal, setOpenModal, saveDocumentFDF, setSaveDocumentFDF }) => {
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);
  const { state, dispatch } = useFormContext();
  const { state: trackingState, dispatch: trackingDispatch } = useTrackingContext();
  const [showPdf, setShowPdf] = useState(false);
  const sigPad = useRef();

  const clear = () => {
    sigPad.current.clear();
  };

  const trim = () => {
    setTrimmedDataURL(sigPad.current.getTrimmedCanvas().toDataURL('image/png'));
    setShowPdf(true);
  };

  const handleUploadDocument = async ({ blob, contentType, size }) => {
    try {
      let reader = new FileReader();
      let base64String = '';
      reader.readAsDataURL(blob);
      reader.onloadend = async function () {
        base64String = reader.result;
        const payload = {
          buffer: base64String,
          contentType,
          size,
          filename: `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state.declarant?.customerIdentityNumber)}`,
          documentType: 'FDF',
        };

        if (state.shortId) {
          try {
            const document = trackingState.documents || [];
            const filename = `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state.declarant?.customerIdentityNumber)}_FDF.pdf`;
            const index = document.findIndex((doc) => doc.documentType.code === 'FDF');
            await putBase64File({ ...payload, documentId: document[index]?.id });
            getUrlFileBase64(filename).then((url) => {
              if (index !== -1) {
                document[index].filename = filename;
                document[index].url = url.data.buffer;
                document[index].status = 'done';
                document[index].state = true;

                dispatch({
                  type: 'UPDATE_DOCUMENTS',
                  payload: [...document],
                });
              }
            });
          } catch (error) {
            console.log(error);
          }
        }

        if (state.vehiclePatente?.deviceId && state.declarant?.customerIdentityNumber) {
          const document = state.state_document || [];
          const filename = `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state.declarant?.customerIdentityNumber)}_FDF.pdf`;
          const index = document.findIndex((doc) => doc.documentType === 'FDF');
          await putBase64File(payload, 'temporal');

          getUrlFileBase64(filename).then((url) => {
            console.log('URL', url);
            if (index !== -1) {
              document[index].url = url.data.buffer;
              document[index].status = 'done';
              document[index].isActive = true;
            }
          });
        }
      };
    } catch (error) {
      console.error(error);
    }
  };
  console.log('state', state);

  return (
    <div className="container">
      {!showPdf ? (
        <>
          <div className="sigContainer">
            <Row justify="center">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <SignaturePad
                  canvasProps={{
                    width: (window.innerWidth * 80) / 100,
                    height: 200,
                    className: 'sigCanvas',
                    style: { border: '1px solid #22B260', width: '100%' },
                  }}
                  ref={sigPad}
                />
              </Col>
            </Row>
          </div>
          <div
            style={{
              width: '100%',
              marginTop: '20px',
            }}
          >
            <Row gutter={16}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Button type="primary" onClick={clear} block size="large">
                  Limpiar Firma
                </Button>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Button type="primary" onClick={trim} block size="large">
                  Generar Documento Firmado
                </Button>
              </Col>
            </Row>
          </div>
        </>
      ) : (
        <div
          style={{
            width: '100%',
            marginTop: '20px',
          }}
        >
          <Row gutter={16}>
            {trimmedDataURL && (
              <>
                <BlobProvider document={<SignatureDeclarations state={state} />}>
                  {({ blob, url, loading, error }) => {
                    // Do whatever you need with blob here
                    if (blob && state) {
                      handleUploadDocument({
                        blob: blob,
                        contentType: blob.type,
                        size: blob.size,
                      });
                    }
                    return;
                  }}
                </BlobProvider>

                <PDFViewer
                  style={{
                    width: '100%',
                    height: '800px',
                    marginBottom: '19px',
                  }}
                >
                  <SignatureDeclarations imgFirma={trimmedDataURL} state={state} />
                </PDFViewer>
              </>
            )}

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Button onClick={() => setShowPdf(false)} type="primary" block size="large">
                Volver a Firmar
              </Button>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Button
                onClick={() => {
                  setOpenModal(false);
                  setShowPdf(false);
                  setSaveDocumentFDF(true);
                }}
                type="primary"
                block
                size="large"
              >
                Guardar y continuar
              </Button>
              {/* <PDFDownloadLink
            document={<SignatureDeclarations imgFirma={trimmedDataURL}/>}
            fileName="myfirstpdf.pdf"
          >
            {({ loading, url, error, blob }) =>
              loading ? (
                <Button
                    
                >Loading Document ...</Button>
              ) : (
                <Button
                        type="primary"
                        block
                        size="large"
                >Guardar y continuar</Button>
              )
            }
          </PDFDownloadLink> */}
            </Col>
          </Row>
        </div>
      )}
      {/* {trimmedDataURL ? (
        <img className="sigImage" src={trimmedDataURL} alt="Signature" />
      ) : null} */}
    </div>
  );
};

export default SignatureForm;
